import { render } from "./BreadcrumbNavigation.vue?vue&type=template&id=62485bb0&ts=true"
import script from "./BreadcrumbNavigation.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__